<style scoped lang="scss">
.container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.page-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    z-index: -1;

    &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -30%;
        width: 80%;
        height: 80%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
        border-radius: 50%;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -20%;
        width: 60%;
        height: 60%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
        border-radius: 50%;
    }
}

.main-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6rem 1.5rem 4rem 1.5rem;
}

.query-box {
    width: 100%;
    max-width: 420px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 2.5rem 2rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);

    .query-title {
        text-align: center;
        margin-bottom: 2rem;

        .title-icon {
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1rem;

            svg {
                width: 24px;
                height: 24px;
                color: #fff;
            }
        }

        h1 {
            font-size: 1.375rem;
            font-weight: 700;
            color: #1a1a2e;
            margin: 0 0 0.5rem 0;
            letter-spacing: -0.02em;
        }

        p {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0;
        }
    }

    .form-group {
        margin-bottom: 1.5rem;

        &:last-of-type {
            margin-bottom: 0;
        }

        label {
            display: block;
            font-size: 0.8125rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.5rem;
            letter-spacing: 0.01em;
        }

        :deep(.el-input__wrapper) {
            background: #f9fafb;
            box-shadow: none;
            border: 1.5px solid #e5e7eb;
            border-radius: 10px;
            padding: 0 1rem;
            height: 3rem;
            transition: all 0.2s ease;

            &:hover {
                border-color: #c4b5fd;
                background: #fff;
            }

            &:focus-within {
                border-color: #8b5cf6;
                background: #fff;
                box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
            }
        }

        :deep(.el-input__inner) {
            height: 2.25rem;
            font-size: 0.9375rem;
            color: #1a1a2e;
            font-weight: 500;

            &::placeholder {
                color: #9ca3af;
                font-weight: 400;
            }
        }

        :deep(.el-input__suffix) {
            color: #9ca3af;
        }

        :deep(.el-select) {
            width: 100%;
        }

        :deep(.el-select__wrapper) {
            background: #f9fafb;
            box-shadow: none;
            border: 1.5px solid #e5e7eb;
            border-radius: 10px;
            padding: 0 1rem;
            height: 3rem;
            transition: all 0.2s ease;

            &:hover {
                border-color: #c4b5fd;
                background: #fff;
            }

            &:focus-within {
                border-color: #8b5cf6;
                background: #fff;
                box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
            }
        }
    }

    .submit-btn {
        width: 100%;
        height: 3rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 0.9375rem;
        font-weight: 600;
        cursor: pointer;
        margin-top: 2rem;
        letter-spacing: 0.01em;
        transition: all 0.25s ease;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
            transition: left 0.5s ease;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 25px -5px rgba(102, 126, 234, 0.4);

            &::before {
                left: 100%;
            }
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 5px 15px -3px rgba(102, 126, 234, 0.3);
        }
    }

    .query-footer {
        text-align: center;
        margin-top: 1.5rem;
        padding-top: 1.5rem;
        border-top: 1px solid #f3f4f6;

        p {
            font-size: 0.75rem;
            color: #9ca3af;
            margin: 0;
        }
    }
}

@media (max-width: 768px) {
    .main-content {
        padding: 5rem 1rem 3rem 1rem;
        align-items: flex-start;
        padding-top: 6rem;
    }

    .query-box {
        max-width: 100%;
        padding: 2rem 1.5rem;
        border-radius: 12px;
        margin-top: 2rem;
    }

    .query-title h1 {
        font-size: 1.25rem;
    }
}
</style>
<template>

    <div class="container">
        <IndexHeader />
        <div class="page-bg"></div>
        <div class="main-content">
            <div class="query-box">
                <div class="query-title">
                    <div class="title-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                    </div>
                    <h1>授权查询</h1>
                    <p>输入授权信息，查询授权状态</p>
                </div>

                <div class="form-group">
                    <label>授权字段</label>
                    <el-input v-model="form.host" placeholder="请输入授权字段(ip/域名/机器码等)" class="mt-3" style="width: 20rem;"
                        clearable></el-input>
                </div>

                <div class="form-group">
                    <label>选择插件</label>
                    <el-select v-model="form.id" placeholder="请选择要查询的插件">
                        <el-option v-for="item in includes_data" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>

                <button class="submit-btn" @click="getQuery">立即查询</button>

                <div class="query-footer">
                    <p>支持域名、IP、卡密等多种方式查询</p>
                </div>
            </div>
        </div>
        <IndexFooter />
    </div>

</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'
import { getIncludesList } from '@/utils/publicMethods'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    name: 'QueryView',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            form: {
                host: "",
                id: "",
            },
            includes_data: [],
        }
    },
    methods: {
        getQuery() {
            openLoading()
            axios.get(baseURL + '/getTime?host=' + this.form.host + '&id=' + this.form.id, { timeout: 5000 })
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => {
                    this.$message.error(err);
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        async getIncludes() {
            const res_data = await getIncludesList(999, 1);
            if (res_data.code != 0) {
                ElMessage.error(res_data.msg)
                return
            }
            this.includes_data = res_data.data
        }
    },
    mounted() {
        this.getIncludes()
    }
})
</script>